export type SessionViewState =
  | { kind: 'connecting' }
  | { kind: 'live'; fps: number; framesDropped: number }
  | { kind: 'reconnecting'; attempt: number }
  | { kind: 'ended'; reason: string }
  | { kind: 'error'; message: string };

export type SessionViewAction =
  | { type: 'connected' }
  | { type: 'tick-stats'; fps: number; framesDropped: number }
  | { type: 'reconnect-start'; attempt: number }
  | { type: 'session-ended'; reason: string }
  | { type: 'error'; message: string };

export const initialSessionViewState: SessionViewState = { kind: 'connecting' };

export function sessionViewReducer(state: SessionViewState, action: SessionViewAction): SessionViewState {
  switch (action.type) {
    case 'connected':
      return { kind: 'live', fps: 0, framesDropped: 0 };
    case 'tick-stats':
      if (state.kind !== 'live') return state;
      return { kind: 'live', fps: action.fps, framesDropped: action.framesDropped };
    case 'reconnect-start':
      return { kind: 'reconnecting', attempt: action.attempt };
    case 'session-ended':
      return { kind: 'ended', reason: action.reason };
    case 'error':
      return { kind: 'error', message: action.message };
  }
}
